import Owl from "./owl.js";

if (window) {
    window.Owl = Owl;
}